// extracted by css-extract-rspack-plugin
export default {"loader":"styles-module__loader--GhBgb","text":"styles-module__text--w_V6z"};